const translationsTermsAndConditions = {
  en: {
    // General
    selectLanguage: 'Select Language',
    english: 'English',
    hindi: 'Hindi',
    marathi: 'Marathi',
    title: 'KhetiSathi-Terms and Conditions',
    lastUpdated: 'Last updated: {date}',

    // Introduction
    introduction: {
      title: 'Introduction',
      content: 'Welcome to KhetiSathi, a platform connecting farmers with drivers and workers for agricultural services. These Terms and Conditions govern your use of our services, including our website and mobile application. By accessing or using KhetiSathi, you agree to comply with these terms.'
    },

    // Acceptance of Terms
    acceptance: {
      title: 'Acceptance of Terms',
      content: 'By registering, accessing, or using KhetiSathi, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. If you do not agree, please do not use our services.'
    },

    // User Responsibilities
    userResponsibilities: {
      title: 'User Responsibilities',
      accurateInfo: 'You agree to provide accurate and complete information during registration and keep it updated.',
      compliance: 'You agree to use the platform in compliance with all applicable laws and regulations.',
      conduct: 'You agree not to engage in any unlawful, fraudulent, or harmful activities while using KhetiSathi.'
    },

    // Services
    services: {
      title: 'Services',
      content: 'KhetiSathi provides a platform to connect farmers with drivers and workers for services such as tractor rentals and farm labor. We are not responsible for the actions of users but facilitate communication and transactions.'
    },

    // Payment Terms
    paymentTerms: {
      title: 'Payment Terms',
      content: 'Payments for services are processed as per the agreed terms between farmers and drivers/workers. KhetiSathi may charge a service fee to drivers, which will be deducted from their earnings.',
      farmers: 'Farmers are responsible for timely payment to drivers and workers as per the agreed cost and payment method.',
      drivers: 'Drivers agree to a 2% service fee on earnings, payable when the service fee wallet reaches ₹100.'
    },

    // Cancellation Policy
    cancellationPolicy: {
      title: 'Cancellation Policy',
      content: 'Farmers may cancel orders within 10 minutes of placement. Cancellations after this period may not be permitted. Drivers and workers may reject assignments as per the platform’s rules, but untimely rejections may affect account status.'
    },

    // Liability
    liability: {
      title: 'Liability',
      content: 'KhetiSathi is not liable for any damages, losses, or injuries arising from the use of our services, including disputes between users or issues with service delivery, to the fullest extent permitted by law.'
    },

    // Termination
    termination: {
      title: 'Termination',
      content: 'KhetiSathi reserves the right to suspend or terminate your account for violations of these terms, including non-payment of service fees or misuse of the platform.'
    },

    // Changes to Terms
    changes: {
      title: 'Changes to Terms',
      content: 'We may update these Terms and Conditions from time to time. Continued use of KhetiSathi after changes constitutes acceptance of the updated terms.'
    },

    // Contact
    contact: {
      title: 'Contact Us',
      content: 'For questions or concerns about these Terms and Conditions, contact us at support@khetisathi.com or +91 7020258039.'
    }
  },
  hi: {
    // General
    selectLanguage: 'भाषा चुनें',
    english: 'अंग्रेजी',
    hindi: 'हिंदी',
    marathi: 'मराठी',
    title: 'खेतीसाथी-नियम और शर्तें',
    lastUpdated: 'आखिरी बार अपडेट किया गया: {date}',

    // Introduction
    introduction: {
      title: 'परिचय',
      content: 'खेतीसाथी में आपका स्वागत है, यह एक ऐसा मंच है जो किसानों को ड्राइवरों और कामगारों के साथ कृषि सेवाओं के लिए जोड़ता है। ये नियम और शर्तें हमारी सेवाओं, जिसमें हमारी वेबसाइट और मोबाइल एप्लिकेशन शामिल हैं, के उपयोग को नियंत्रित करती हैं। खेतीसाथी का उपयोग करने या उस तक पहुंचने से, आप इन शर्तों का पालन करने के लिए सहमत होते हैं।'
    },

    // Acceptance of Terms
    acceptance: {
      title: 'शर्तों की स्वीकृति',
      content: 'खेतीसाथी में पंजीकरण, उपयोग, या पहुंच करके, आप स्वीकार करते हैं कि आपने इन नियमों और शर्तों को पढ़ा, समझा और इनका पालन करने के लिए सहमत हैं। यदि आप सहमत नहीं हैं, तो कृपया हमारी सेवाओं का उपयोग न करें।'
    },

    // User Responsibilities
    userResponsibilities: {
      title: 'उपयोगकर्ता की जिम्मेदारियां',
      accurateInfo: 'आप पंजीकरण के दौरान सटीक और पूर्ण जानकारी प्रदान करने और इसे अपडेट रखने के लिए सहमत हैं।',
      compliance: 'आप सभी लागू कानूनों और नियमों के अनुपालन में मंच का उपयोग करने के लिए सहमत हैं।',
      conduct: 'आप खेतीसाथी का उपयोग करते समय किसी भी गैरकानूनी, धोखाधड़ी, या हानिकारक गतिविधियों में शामिल न होने के लिए सहमत हैं।'
    },

    // Services
    services: {
      title: 'सेवाएं',
      content: 'खेतीसाथी ट्रैक्टर किराए और खेत श्रम जैसी सेवाओं के लिए किसानों को ड्राइवरों और कामगारों से जोड़ने के लिए एक मंच प्रदान करता है। हम उपयोगकर्ताओं के कार्यों के लिए जिम्मेदार नहीं हैं, लेकिन संचार और लेनदेन की सुविधा प्रदान करते हैं।'
    },

    // Payment Terms
    paymentTerms: {
      title: 'भुगतान की शर्तें',
      content: 'सेवाओं के लिए भुगतान किसानों और ड्राइवरों/कामगारों के बीच सहमति के अनुसार संसाधित किए जाते हैं। खेतीसाथी ड्राइवरों से सेवा शुल्क ले सकता है, जो उनकी कमाई से काटा जाएगा।',
      farmers: 'किसान सहमत लागत और भुगतान विधि के अनुसार ड्राइवरों और कामगारों को समय पर भुगतान करने के लिए जिम्मेदार हैं।',
      drivers: 'ड्राइवर अपनी कमाई पर 2% सेवा शुल्क के लिए सहमत हैं, जो सेवा शुल्क वॉलेट ₹100 तक पहुंचने पर देय होगा।'
    },

    // Cancellation Policy
    cancellationPolicy: {
      title: 'रद्द करने की नीति',
      content: 'किसान ऑर्डर देने के 10 मिनट के भीतर ऑर्डर रद्द कर सकते हैं। इस अवधि के बाद रद्दीकरण की अनुमति नहीं हो सकती। ड्राइवर और कामगार मंच के नियमों के अनुसार असाइनमेंट को अस्वीकार कर सकते हैं, लेकिन असामयिक अस्वीकृति खाता स्थिति को प्रभावित कर सकती है।'
    },

    // Liability
    liability: {
      title: 'दायित्व',
      content: 'कानून द्वारा अनुमत अधिकतम सीमा तक, खेतीसाथी हमारी सेवाओं के उपयोग से उत्पन्न होने वाली किसी भी क्षति, हानि, या चोटों के लिए उत्तरदायी नहीं है, जिसमें उपयोगकर्ताओं के बीच विवाद या सेवा वितरण के मुद्दे शामिल हैं।'
    },

    // Termination
    termination: {
      title: 'समाप्ति',
      content: 'खेतीसाथी इन शर्तों के उल्लंघन, जिसमें सेवा शुल्क का गैर-भुगतान या मंच का दुरुपयोग शामिल है, के लिए आपके खाते को निलंबित या समाप्त करने का अधिकार सुरक्षित रखता है।'
    },

    // Changes to Terms
    changes: {
      title: 'शर्तों में परिवर्तन',
      content: 'हम समय-समय पर इन नियमों और शर्तों को अपडेट कर सकते हैं। परिवर्तनों के बाद खेतीसाथी का निरंतर उपयोग अद्यतन शर्तों की स्वीकृति को दर्शाता है।'
    },

    // Contact
    contact: {
      title: 'हमसे संपर्क करें',
      content: 'इन नियमों और शर्तों के बारे में प्रश्नों या चिंताओं के लिए, हमसे support@khetisathi.com या +91 7020258039 पर संपर्क करें।'
    }
  },
  mr: {
    // General
    selectLanguage: 'भाषा निवडा',
    english: 'इंग्रजी',
    hindi: 'हिंदी',
    marathi: 'मराठी',
    title: 'खेतीसाथी-नियम आणि अटी',
    lastUpdated: 'शेवटचे अद्यतन: {date}',

    // Introduction
    introduction: {
      title: 'प्रस्तावना',
      content: 'खेतीसाथी मध्ये आपले स्वागत आहे, हे एक व्यासपीठ आहे जे शेतकऱ्यांना ड्रायव्हर्स आणि कामगारांशी शेती सेवांसाठी जोडते. या नियम आणि अटी आमच्या सेवांचा वापर, ज्यामध्ये आमची वेबसाइट आणि मोबाइल अॅप्लिकेशन समाविष्ट आहे, यावर नियंत्रण ठेवतात. खेतीसाथी चा वापर करून किंवा त्यात प्रवेश करून, आपण या अटींचे पालन करण्यास सहमती देता.'
    },

    // Acceptance of Terms
    acceptance: {
      title: 'अटींची स्वीकृती',
      content: 'खेतीसाथी मध्ये नोंदणी, वापर, किंवा प्रवेश करून, आपण हे मान्य करता की आपण या नियम आणि अटी वाचल्या, समजल्या आणि त्यांचे पालन करण्यास सहमती देता. जर आपण सहमत नसाल, तर कृपया आमच्या सेवांचा वापर करू नका.'
    },

    // User Responsibilities
    userResponsibilities: {
      title: 'वापरकर्त्याच्या जबाबदाऱ्या',
      accurateInfo: 'आपण नोंदणीच्या वेळी अचूक आणि पूर्ण माहिती प्रदान करण्यास आणि ती अद्यतन ठेवण्यास सहमती देता.',
      compliance: 'आपण सर्व लागू कायदे आणि नियमांचे पालन करून व्यासपीठाचा वापर करण्यास सहमती देता.',
      conduct: 'आपण खेतीसाथी चा वापर करताना कोणत्याही बेकायदेशीर, फसव्या, किंवा हानिकारक कृतींमध्ये सहभागी न होण्यास सहमती देता.'
    },

    // Services
    services: {
      title: 'सेवा',
      content: 'खेतीसाथी ट्रॅक्टर भाड्याने आणि शेती कामगार यांसारख्या सेवांसाठी शेतकऱ्यांना ड्रायव्हर्स आणि कामगारांशी जोडण्यासाठी एक व्यासपीठ प्रदान करते. आम्ही वापरकर्त्यांच्या कृतींसाठी जबाबदार नाही, परंतु संवाद आणि व्यवहारांना सुलभ करतो.'
    },

    // Payment Terms
    paymentTerms: {
      title: 'पेमेंट अटी',
      content: 'सेवांसाठी पेमेंट शेतकरी आणि ड्रायव्हर्स/कामगार यांच्यातील सहमतीनुसार प्रक्रिया केले जाते. खेतीसाथी ड्रायव्हर्सकडून सेवा शुल्क आकारू शकते, जे त्यांच्या कमाईतून कपात केले जाईल.',
      farmers: 'शेतकरी सहमतीप्रमाणे खर्च आणि पेमेंट पद्धतीनुसार ड्रायव्हर्स आणि कामगारांना वेळेवर पेमेंट करण्यास जबाबदार आहेत.',
      drivers: 'ड्रायव्हर्स त्यांच्या कमाईवर 2% सेवा शुल्कास सहमती देतात, जे सेवा शुल्क वॉलेट ₹100 पर्यंत पोहोचल्यावर देय आहे.'
    },

    // Cancellation Policy
    cancellationPolicy: {
      title: 'रद्दीकरण धोरण',
      content: 'शेतकरी ऑर्डर दिल्यानंतर 10 मिनिटांत ऑर्डर रद्द करू शकतात. या कालावधीनंतर रद्दीकरणाला परवानगी मिळू शकत नाही. ड्रायव्हर्स आणि कामगार व्यासपीठाच्या नियमांनुसार असाइनमेंट नाकारू शकतात, परंतु वेळेवर नाकारण्याचा परिणाम खाते स्थितीवर होऊ शकतो.'
    },

    // Liability
    liability: {
      title: 'दायित्व',
      content: 'कायद्याने परवानगी दिलेल्या कमाल मर्यादेपर्यंत, खेतीसाथी आमच्या सेवांच्या वापरामुळे उद्भवणाऱ्या कोणत्याही नुकसानी, हानी, किंवा दुखापतींसाठी, ज्यामध्ये वापरकर्त्यांमधील वाद किंवा सेवा वितरणातील समस्यांचा समावेश आहे, जबाबदार नाही.'
    },

    // Termination
    termination: {
      title: 'समाप्ती',
      content: 'खेतीसाथी या अटींचे उल्लंघन, ज्यामध्ये सेवा शुल्काचा गैर-पेमेंट किंवा व्यासपीठाचा गैरवापर समाविष्ट आहे, यासाठी आपले खाते निलंबित किंवा समाप्त करण्याचा अधिकार राखून ठेवते.'
    },

    // Changes to Terms
    changes: {
      title: 'अटींमध्ये बदल',
      content: 'आम्ही वेळोवेळी या नियम आणि अटी अद्यतन करू शकतो. बदलांनंतर खेतीसाथी चा सतत वापर अद्यतन अटींची स्वीकृती दर्शवतो.'
    },

    // Contact
    contact: {
      title: 'आमच्याशी संपर्क साधा',
      content: 'या नियम आणि अटींबाबत प्रश्न किंवा चिंतांसाठी, support@khetisathi.com किंवा +91 7020258039 वर आमच्याशी संपर्क साधा.'
    }
  }
};

export default translationsTermsAndConditions;